module.exports = __webpack_public_path__ + "img/create_gist_documentation.80673463.png";